import * as __WEBPACK_EXTERNAL_MODULE__utils_isString_mjs_59402478__ from "../utils/isString.mjs";
const isActionOption = (it)=>'object' == typeof it && null !== it && 'type' in it && 'pattern' in it && (0, __WEBPACK_EXTERNAL_MODULE__utils_isString_mjs_59402478__.isString)(it.type) && (0, __WEBPACK_EXTERNAL_MODULE__utils_isString_mjs_59402478__.isString)(it.pattern);
export { isActionOption };

//# sourceMappingURL=redactedFieldsConfig.mjs.map